// Auto generated by ControleTool.ModelClassGenerator
import { inject } from 'aurelia-framework';
import { ValidationRules } from 'aurelia-validation';
import { Helpers } from '../services/helpers';
import { AssignmentIndexViewModel } from './assignmentindexview-model';
import { AnswerViewModel } from './answerview-model';


export class SubAssignmentIndexViewModel {
    id: number = 0;
	order: number = 0;
	description: string = null;
	assignmentId: number = 0;
	assignment: AssignmentIndexViewModel = null;
	answers: AnswerViewModel[] = null;
	totalImportance: number = 0;
	totalScored: number = 0;
	
	constructor(data: any = null) {
        
		if (data) {
			Helpers.mapProperties(data, this);
        }
        ValidationRules
			.ensure('order').displayName('Volgorde').required()
			.ensure('description').displayName('Omschrijving').required()
			.ensure('assignmentId').displayName('Opdracht').required()
			.on(this);
	}
}